import React, { useEffect, useState } from "react";
import { AppBar, Box, CssBaseline, Drawer, Toolbar, Typography } from '@mui/material';
import '../../assets/styles.css';
import { getMethod } from "../../services/apiService";
import { clearStorageAndCookies } from "../../services/authService";
import { useNavigate } from 'react-router-dom';
import { Form as RBFORM } from 'react-bootstrap';
import { Field } from 'formik';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link, useLocation } from "react-router-dom";
import { PartnerIdContext, usePartnerIdContext } from "../../context/partnerIdContext";
import {PROFILE_TYPE} from "../../helper/globalConstant"
// Define the interface for the props
interface HeaderProps {
    title: string;
    breadCrumb?: any;
}

interface User {
    centralUser: UserData;
}

interface UserData {
    userId: string;
    profileId: number;
    superadmin: boolean;
    name: string;
    lastName: string;
    address: Address;
    mailId: string;
    mobile: string;
    sequrityQuestion1?: string;
    sequrityAnswer1?: string;
    sequrityQuestion2?: string;
    sequrityAnswer2?: string;
    lastLoginTime: number;
    logedId: boolean;
    machineUser: number;
    sites: any[];
    enterprises: any[];
    accountStatus: string;
    profilePhoto: string;
}

interface Address {
    state: string;
}

const Header: React.FC<HeaderProps> = ({ title, breadCrumb }: any) => {

    const navigate = useNavigate();
    const location = useLocation();
    const partnerIdContext = usePartnerIdContext();
    const [profileId, setProfileId] = useState<number | null>(null);
    const [partnerId, setPartnerId] = useState(localStorage.getItem("partnerId") || ""); // Initialize from localStorage
    const [setData, setUserData] = useState<User[]>([]);
    const [isDisplayPartnerDropdown, setIsDisplayPartnerDropdown] = useState(true);


    /* useEffect(() => {
        //if (title != "User" && title != "Customer Overview") {
            const sess_user_data = localStorage.getItem("sess_user");

            if (sess_user_data != null) {
                try {
                    const sess_user = JSON.parse(sess_user_data); // Parse session data

                    // Safely extract profileId
                    const extractedProfileId = sess_user?.userProfile?.profileId;
                    if (extractedProfileId) {
                        setProfileId(extractedProfileId);
                    } else {
                        console.error("Profile ID not found in userProfile");
                    }
                } catch (error) {
                    console.error("Error parsing session user data:", error);
                }
            }


            if (profileId === 100) {
                getUsers();
            }
        //}
    }, [profileId]); */



    useEffect(() => {
        partnerIdContext.setIsDisplay(false);
        const sess_user_data = localStorage.getItem("sess_user");
        if (sess_user_data != null) {
            try {
                const sess_user = JSON.parse(sess_user_data); // Parse session data
                // Safely extract profileId
                const extractedProfileId = sess_user?.userProfile?.priority;
                if (extractedProfileId) {
                    setProfileId(extractedProfileId);
                    
                    if (extractedProfileId === PROFILE_TYPE.SUPER_ADMIN) {
                        getUsers();

                        if ((location?.pathname.startsWith('/customer/overview') ||
                            location?.pathname.startsWith('/licenses') ||
                            location?.pathname.startsWith('/orders')) && (!location?.pathname.startsWith('/orders/details'))
                        ) {
                            partnerIdContext.setIsDisplay(true);
                        } else {
                            partnerIdContext.setIsDisplay(false);
                        }
                    } else {
                        partnerIdContext.setIsDisplay(false);
                    }
                } else {
                    console.error("Profile ID not found in userProfile");
                }
            } catch (error) {
                console.error("Error parsing session user data:", error);
            }
        }
    }, []);

    const getUsers = async () => {
        const apiEndpoint = `central/user/priority/${PROFILE_TYPE.INTEGRATOR}`;
        const response = await getMethod(apiEndpoint);

        // Check if response is valid
        if (response?.data?.code === 200) {

            const fetchedUsers = response.data?.result.sort((a: any, b:any) => {
                if (a.centralUser.name > b.centralUser.name) return 1;
                if (a.centralUser.name < b.centralUser.name) return -1;
                return 0;
              });
            setUserData(fetchedUsers);

            const sess_user_data = localStorage.getItem("sess_user");
            let extractedName = "";
            if (sess_user_data != null) {
                const sess_user = JSON.parse(sess_user_data); // Parse session data
                extractedName = sess_user?.user?.userId;
                console.log()
            }

            if ((!localStorage.getItem("partnerId") || localStorage.getItem("partnerId") === extractedName)
                && fetchedUsers.length > 0) {

                const firstUserId = fetchedUsers[0].centralUser.userId; // Default to the first user
                setPartnerId(firstUserId);
                localStorage.setItem("partnerId", firstUserId); // Store default partnerId in localStorage
                if (partnerIdContext) {
                    partnerIdContext.setPartnerId(firstUserId); // Set the context to the first userId
                }
            }


        } else {
            console.error("Failed to fetch users", response?.data);
        }
    };


    const handlePartnerChange = (e: any) => {
        const selectedPartnerId = e.target.value;
        setPartnerId(selectedPartnerId);
        localStorage.setItem("partnerId", selectedPartnerId); // Update partnerId in localStorage
        if (partnerIdContext) {
            partnerIdContext.setPartnerId(selectedPartnerId);
        }
    };


    useEffect(() => {
        if (partnerIdContext) {
            setIsDisplayPartnerDropdown(partnerIdContext.isDisplay);
        }
    }, [partnerIdContext.isDisplay]);


    useEffect(() => {
        return () => partnerIdContext.setIsDisplay(true);
    }, [])




    return (
        <>
            <AppBar className="TopHeader" position="fixed" sx={{ zIndex: 1 }}>
                <Toolbar
                    sx={{
                        display: 'flex',
                        justifyContent: breadCrumb ? 'left' : 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        variant="h6"
                        noWrap
                        sx={{
                            overflow: 'none',
                            paddingLeft: '75px',
                            fontSize: '24px',
                            gap: '8px'
                        }}
                    >
                        {title}
                    </Typography>

                    {breadCrumb ?
                        <Box sx={{ display: 'flex', gap: '10px' }}>
                            {breadCrumb?.map((i: any, index: any) => {
                                const isLast = breadCrumb?.length === index + 1;
                                return (
                                    <Typography
                                        key={index}
                                        sx={{ color: isLast ? "#A5A8A9" : "#17B2EB" }}
                                    >
                                        {!isLast ? (
                                            <Link
                                                to={i?.path}
                                                style={{ color: "unset", textDecoration: "none" }}
                                            >
                                                {i?.label}
                                            </Link>
                                        ) : (
                                            i?.label
                                        )}
                                        {!isLast && (
                                            <ArrowForwardIosIcon
                                                sx={{
                                                    height: "12px",
                                                    width: "14px",
                                                    fill: "#17B2EB",
                                                }}
                                            />
                                        )}
                                    </Typography>
                                );
                            })}

                        </Box>
                        : ""}

                    {isDisplayPartnerDropdown &&
                        <>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    gap: '16px', // Add space between child elements
                                    position: "absolute",
                                    right: "0"
                                }}
                            >
                                <Typography>
                                    Partners
                                </Typography>
                                <FormControl
                                    sx={{
                                        minWidth: 200,
                                        marginRight: '16px',
                                        '& .MuiInputLabel-root': {
                                            color: 'white',
                                        },
                                    }}
                                    size="small"
                                >
                                    <Select
                                        name="partnerList"
                                        value={partnerId}
                                        onChange={(e) => handlePartnerChange(e)}
                                        sx={{
                                            borderColor: '#5A5F60',
                                            height: '40px',
                                            borderRadius: '25px',
                                            borderWidth: '1px',
                                            borderStyle: 'solid',
                                            backgroundColor: '#03171F',
                                            color: '#E2E3E3 !important',
                                            width: '250px',
                                            fontWeight: '400',
                                            fontSize: '14px',
                                            paddingLeft: '20px',
                                            textAlign: 'left',
                                        }}
                                        inputProps={{
                                            MenuProps: {
                                              PaperProps: {
                                                sx: {
                                                   backgroundColor: '#1F2F34 !important'
                                                }
                                              }
                                            }
                                          }}
                                    >
                                        {setData?.length > 0 ? (
                                            setData.map((user: any) => (
                                                <MenuItem key={user.centralUser.userId} value={user.centralUser.userId}>
                                                    {user.centralUser.name} {user.centralUser.lastName}
                                                </MenuItem>
                                            ))
                                        ) : (
                                            <MenuItem value="" disabled>
                                                Select Partner
                                            </MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </Box>

                        </>
                    }


                </Toolbar>
            </AppBar>

        </>
    );
};


export default Header;
